import { render } from "./ChevronDown.vue?vue&type=template&id=0aa72031"
import script from "./ChevronDown.vue?vue&type=script&lang=js"
export * from "./ChevronDown.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ChevronDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aa72031"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aa72031', __exports__)) {
    api.reload('0aa72031', __exports__)
  }
  
  module.hot.accept("./ChevronDown.vue?vue&type=template&id=0aa72031", () => {
    api.rerender('0aa72031', render)
  })

}


export default __exports__